import {EsquireClient} from "@/types/clients/esquire";
import ExtendReservationData
  from "@/types/clients/esquire/requests/payment/extend-reservation-data";

export default class ExtendReservation {
  constructor(private client: EsquireClient) {}

  public async send(payment: ExtendReservationData) {

    const url = await this.client.fetchUrlFromSession("extend-reservation");

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payment.toJsonObject())
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      throw new Error("Failed to initiate payment");
    }

    return response.ok;
  }
}
